import { defineAsyncComponent } from 'vue';

export default {};
